// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"643":"3f87a431","800":"c0b0bda5"}[chunkId] + ".css";
};